/**
 * The nearest ancestor-or-self of an event's target matching `selector`, or
 * null. An event target is typed `EventTarget`, which may be a node that has
 * no `closest` (a text node, the window), so this narrows before asking.
 */
export const closestFrom = (target: EventTarget | null, selector: string): Element | null =>
  target instanceof Element ? target.closest(selector) : null;
